import { FC, useEffect, useContext, useState, useLayoutEffect } from "react";
import { useSearchParams } from "react-router-dom";

import { format } from "date-fns";
import FooterText from "src/components/footerText";
import AuthMaunfacturerSubHeader from "src/components/manufacturer/authManufacturerSubHeader";
import { GeographicalStatisticsObject } from "./types";
import CaseFilter from "src/components/manufacturer/statistics";
import GeographicalStatistics from "src/components/manufacturer/geographicalStatistics";
import CaseVolume from "src/components/manufacturer/caseVolume";
import KAMsRBDsFAMs from "src/components/manufacturer/TBMsRBDsFRMs";
import Top10Payors from "src/components/manufacturer/top10Payors";
// import Top10Diagnoses from "src/components/manufacturer/top10Diagnoses";


import { ToastContext } from "src/context/toastContext";
import { LoaderContext } from "src/context/loaderContext";
import { ToastTypes } from "src/types";
import { StatisticsSearchProps } from "src/components/manufacturer/statistics/types";
import useFetch from "src/hooks/useFetch";
import { APIEndpoints } from "src/types/apiTypes";
import CustomPieChart from "src/components/manufacturer/customPieChart";
import { FAMsList, KAMsList, RBDsList } from "src/components/manufacturer/TBMsRBDsFRMs/types";
import { StatisticsApiResponse } from "../territories/types";




const Manufacturer: FC = (): JSX.Element => {
  const [searchParams, updateSearchParams ] = useSearchParams();
  const [queryParams, changeQueryParams] = useState({
    start_date: searchParams.get('start_date') || format((new Date()).setDate((new Date()).getDate() - 60), "yyyy-MM-dd"),
    end_date: searchParams.get('end_date') || format((new Date()).setDate((new Date()).getDate() + 1), "yyyy-MM-dd"),
    period: searchParams.get('period') || "day",
    filter: searchParams.get('filter') || "",
    filter_type: searchParams.get('filter_type') || "",
    type: "index",
    role: "manufacturer",
    id: searchParams.get('id') || "",
  });

  const { showToast } = useContext(ToastContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);


  // eslint-disable-next-line react-hooks/exhaustive-deps
  useLayoutEffect (()=> setLoader(), []);



  // const { start_date, end_date, ...cleanedQueries } = queryParams;
  const { loading: statisticsLoading, error: statisticsError, data: statisticsData, mutate: getStatsData } =
    useFetch<StatisticsApiResponse>(APIEndpoints.MANUFACTURE_STATISTICS, queryParams, {}, false);

  useEffect(() => {
    if (statisticsData) {
      hideLoader();
        if (statisticsData.code === 200) {
          showToast([statisticsData.message], ToastTypes.SUCCESS);
        }
    }else if(statisticsError){
      hideLoader();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statisticsData]);

  const updateQueryParamsAndCallAPI = (updatedQueries: StatisticsSearchProps, isReset: boolean = false): void => {
    if (isReset) {
      updateSearchParams({});
      changeQueryParams({
        start_date: format((new Date()).setDate((new Date()).getDate() - 60), "yyyy-MM-dd"),
        end_date: format((new Date()).setDate((new Date()).getDate() + 1), "yyyy-MM-dd"),
        period: "day",
        filter: "",
        filter_type: "",
        type: "index",
        role: "manufacturer",
        id: searchParams.get('id') || "",
      });
    } else {
      const params = new URLSearchParams({ ...queryParams, ...updatedQueries });
      updateSearchParams(params.toString(), { replace: false });
      changeQueryParams({ ...queryParams, ...updatedQueries });
    }
    // const { start_date, end_date, ...cleanedQueries } = updatedQueries;
    setLoader()
    getStatsData({}, {}, updatedQueries);
  };

  useEffect(() => {
    const updatedParams = {
      start_date: searchParams.get('start_date') || format((new Date()).setDate((new Date()).getDate() - 60), "yyyy-MM-dd"),
      end_date: searchParams.get('end_date') || format((new Date()).setDate((new Date()).getDate() + 1), "yyyy-MM-dd"),
      period: searchParams.get('period') || "day",
      filter: searchParams.get('filter') || "",
      filter_type: searchParams.get('filter_type') || "",
      type: "index",
      role: "manufacturer",
      id: searchParams.get('id') || "",
    };
    if (!statisticsLoading) {
      setLoader();
      changeQueryParams(updatedParams);
      getStatsData({}, {}, updatedParams);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  return (
    <div className="container-fluid auth-page mb-4 overflow-x-hidden overflow-auto">
      <AuthMaunfacturerSubHeader />

      <CaseFilter defaultQueryParams={queryParams} updateQueryParams={updateQueryParamsAndCallAPI} />

      {statisticsData && statisticsData.data && (
        <CaseVolume StatisticsObjectType={statisticsData.data} />
      )}

      {statisticsData && statisticsData.data && (
        <Top10Payors StatisticsObjectType={statisticsData.data} />
      )}

      {statisticsData && statisticsData.data && (
        <CustomPieChart title={'Top 10 Diagnoses'} pieChartObject={statisticsData.data.diagnosis}/>
      )}

      {statisticsData && statisticsData.data && (
        <KAMsRBDsFAMs
          KAMsListType={statisticsData.data.kams && statisticsData.data.kams as unknown as KAMsList}
          FAMsListType={statisticsData.data.fams && statisticsData.data.fams as unknown as FAMsList}
          RBDsListType={statisticsData.data.rbds && statisticsData.data.rbds as unknown as RBDsList}
          defaultQueryParams={queryParams} 
          updateQueryParams={updateQueryParamsAndCallAPI}
        />
      )}

      {statisticsData && statisticsData.data && (
        <GeographicalStatistics
          GeographicalStatisticsListType={
            statisticsData.data.geographical_stats as unknown as GeographicalStatisticsObject[]
          }
        />
      )}

      <FooterText/>
    </div>
  );
};

export default Manufacturer;
